<template>
  <div class="maintain" v-if="funcView.feed_back_manage_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item v-if="funcView.feed_back_manage_export" style="float: right; margin-right: 0">
          <el-button class="table-set" @click.native="exportTable('feedbackExport', { ...formSearch, exportTableCode: tableCode })">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right" :style="{ 'margin-right': !funcView.feed_back_manage_export ? 0 : '' }">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('asm_done.zlfhdhljmcljbh')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('asm_done.shen_qing_shi_jian')">
          <custom-date-picker
            v-model="formSearch.dataTimes"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width: 100%"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('asm_done.chan_pin_xing_hao')">
          <custom-select
            url="productCodeSelectList"
            v-model="formSearch.productCode"
            :props="{ label: 'productCode', value: 'productCode' }"
            :placeholder="$t('Common.com_please_select')"
            width="100%"
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('asm_done.shen_qing_zu_zhi')">
          <el-input v-model="formSearch.applyOrgName"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table height="100%" :data="tableList" @filter="filterChange" @sort="sortChange" :slots="['workOrderCode', 'action']" :tableCode="tableCode" @column="setColumn">
        <template v-slot:workOrderCode="scope">
          <span class="watch-detail" @click="watchDetail(scope.row)">{{ scope.row.workOrderCode }}</span>
        </template>
        <template v-slot:action="scope">
          <el-button type="text" size="mini" @click="onPreview(scope.row)" v-if="funcView.feed_back_manage_preview">{{ funcView.feed_back_manage_preview }}</el-button>
          <!-- 更多操作 -->
          <el-dropdown style="vertical-align: top" v-show="scope.row.showMoreAction">
            <el-button type="text" size="mini">
              <span>{{ $t('Common.com_more_action')}}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="onEditDone(scope.row)" v-if="isHq && funcView.feed_back_manage_edit_result">
                {{ funcView.feed_back_manage_edit_result }}{{ showMore(scope.row) }}
              </el-dropdown-item>
              <el-dropdown-item @click.native="onPrint(scope.row)" v-if="funcView.feed_back_manage_print">{{ funcView.feed_back_manage_print }}{{ showMore(scope.row) }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- 编辑审批内容 -->
    <feedBack-editDone-dialog v-if="dialogVisible" @close="dialogVisible = false" :model="dialogModel" @success="onPageChange({ page: 1 })"></feedBack-editDone-dialog>
    <feedBack-print-dialog v-if="dialogVisible2" @close="dialogVisible2 = false" :model="dialogModel2" ></feedBack-print-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import feedBackEditDoneDialog from '@/pages/asm/components/feedBack_editDone_dialog';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import feedBackPrintDialog from './feedBack_print_dialog';

export default {
  name: 'done',
  mixins: [resetFormSearchMixins],
  components: {
    feedBackEditDoneDialog,
    feedBackPrintDialog,
  },
  props: {
    isHq: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        type: 2,
        flowNodeNo: '100',
        dataTimes: '',
        startTime: '',
        endTime: '',
        productCode: '',
      },
      totalRows: null,
      tableList: [],

      // 编辑已完成的结果
      dialogModel: {},
      dialogVisible: false,
      // 打印
      dialogModel2: {},
      dialogVisible2: false,
      link: null,
    };
  },
  computed: {
    tableCode() {
      return this.isHq ? 'feedBack_hq_undone' : 'feedBack_undone';
    },
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    // 更多操作
    showMore: function (row) {
      this.$set(row, 'showMoreAction', true);
      return '';
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    getTableList() {
      this.formSearch.startTime = this.formSearch.dataTimes && this.formSearch.dataTimes[0] ? this.formSearch.dataTimes[0] : undefined;
      this.formSearch.endTime = this.formSearch.dataTimes && this.formSearch.dataTimes[1] ? this.formSearch.dataTimes[1] : undefined;
      this.$getJSON(apis.feedbackPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    watchDetail(row, options = {}) {
      this.jump('/workorder/workOrderDetail', {
        orderType: 'workOrder',
        caseOrderType: row.workOrderType,
        caseOrderId: row.caseOrderId,
        workOrderId: row.workOrderId,
        ...options,
      });
    },
    onPrint(row) {
      this.dialogModel2 = {
        title: this.$t('asm_done.zlfkbg'),
        type: 'edit',
        data: row,
      };
      this.dialogVisible2 = true;
    },
    // 查看质量反馈详情
    onPreview(row) {
      this.jump('/redirect/workorder/feedBackDetail', {
        feedBackId: row.feedBackId,
      });
    },
    // 编辑审批内容
    onEditDone(row) {
      this.dialogVisible = true;
      this.dialogModel = {
        title: this.$t('asm_done.bian_ji_shen_pi'),
        data: row,
        type: 'edit',
      };
    },
  },
  created() {},
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableList();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
  },
};
</script>

<style lang="scss" scoped>
.maintain {
  padding: 0 16px 0 16px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .watch-detail {
    text-decoration: underline;
    cursor: pointer;
    color: #0d9ae0;
  }
}
</style>
